export const STATE_DISTRICT_MAP = {
    Tamilnadu: [
        'Ariyalur',
        'Chengalpattu',
        'Chennai',
        'Coimbatore',
        'Cuddalore',
        'Dharmapuri',
        'Dindigul',
        'Erode',
        'Kallakurichi',
        'Kancheepuram',
        'Kanniyakumari',
        'Karur',
        'Krishnagiri',
        'Madurai',
        'Mayiladuthurai',
        'Nagapattinam',
        'Namakkal',
        'Nilgiris',
        'Perambalur',
        'Pudukkottai',
        'Ramanathapuram',
        'Ranipet',
        'Salem',
        'Sivagangai',
        'Tenkasi',
        'Thanjavur',
        'Theni',
        'Thoothukudi',
        'Tiruchirappalli',
        'Tirunelveli',
        'Tirupathur',
        'Tiruppur',
        'Tiruvallur',
        'Tiruvannamalai',
        'Tiruvarur',
        'Vellore',
        'Viluppuram',
        'Virudhunagar',
    ],
    Karnataka: [
        'Bagalkot',
        'Ballari',
        'Belagavi',
        'Bengaluru Rural',
        'Bengaluru Urban',
        'Bidar',
        'Vijayapura',
        'Chamarajanagar',
        'Chikkaballapur',
        'Chikkamagaluru',
        'Chitradurga',
        'Dakshina Kannada',
        'Davanagere',
        'Dharwad',
        'Gadag',
        'Hassan',
        'Haveri',
        'Kalaburagi',
        'Kodagu',
        'Kolar',
        'Koppal',
        'Mandya',
        'Mysuru',
        'Raichur',
        'Ramanagara',
        'Shivamogga',
        'Tumakuru',
        'Udupi',
        'Uttara Kannada',
        'Vijayanagara',
        'Yadgir',
    ],
    Kerala: [
        'Alappuzha',
        'Ernakulam',
        'Idukki',
        'Kannur',
        'Kasaragod',
        'Kollam',
        'Kottayam',
        'Kozhikode',
        'Malappuram',
        'Palakkad',
        'Pathanamthitta',
        'Thiruvananthapuram',
        'Thrissur',
        'Wayanad',
    ],
};

export const STATES = Object.keys(STATE_DISTRICT_MAP);

export const getDistrictsForState = (state) => STATE_DISTRICT_MAP[state] || [];
